<template>
    <div :id="getBoyingId('lexin-boying')" class="ordbank-highlight">
        <div v-if="showLemma">
            <ul v-if="(boyingResult.lemma_rows.length || []) > 0">
                <li v-for="(lemma_row, key) in boyingResult.lemma_rows">
                    <span v-if="lemma_row.lemma || '' ">
                        <span :id="getlemmaSpeakerId(key)">{{ lemma_row.lemma || '' }}</span>
                        <SpeakTextContent />
                    </span>
                    <span v-for="(pronunciation_item, pron_key) in lemma_row.pronunciation_list || []">
                        <span v-if="pron_key > 0 && pronunciation_item.value || ''" >, </span><Pronunciation v-if="pronunciation_item.value || ''" :value="pronunciation_item.value" class_value="pronunciation" />
                    </span>
                </li>
            </ul>
        </div>

        <label v-if="showHeader && ((boyingResult.header || false) || (boyingResult.sub_header || false))">
            <span class="text-lowercase" v-if="hasHeaderValue()">{{ getHeaderValue() }}</span>
            <em v-if="getSubHeaderValue() || false" class="text-lowercase">{{ getSubHeaderValue() }}</em>
        </label>

        <div class="ordbank-table" v-if="hasContent()">
            <LexinBoyingResultInflectionTable
                :id="id"
                :languageCode="languageCode"
                type="main"
                :boyingResult="boyingResult"
                @updateMouseOver="handleMouseOver"
            />

            <div class="ordbank-table additional" v-if="boyingResult.inflection_rows_additional.show">

                <details :open="getOpenPartisipp()" v-if="showAdditionalOpenCloseDetails()">
                    <summary
                        :data-hidetitle="$t('message.ordbank_click_for_hide_info')"
                        :data-showtitle="$t('message.ordbank_click_for_more_info')"
                    >
                        <span class="show-inflection">{{ $t("message.ordbank_show_info_about_partisipp") }}</span>
                        <span class="hide-inflection">{{ $t("message.ordbank_hide_info_about_partisipp") }}</span>
                    </summary>

                    <LexinBoyingResultInflectionTable
                        :id="id"
                        :languageCode="languageCode"
                        type="additional"
                        :boyingResult="boyingResult"
                        @updateMouseOver="handleMouseOver"
                        />

                </details>
                <div class="additional" v-else>
                    <LexinBoyingResultInflectionTable
                        :id="id"
                        :languageCode="languageCode"
                        type="additional"
                        :boyingResult="boyingResult"
                        @updateMouseOver="handleMouseOver"
                    />
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import SpeakTextContent from "./SpeakTextContent.vue";
import Pronunciation from "./Pronunciation.vue";
import LexinBoyingResultInflectionTable from "./LexinBoyingResultInflectionTable.vue";

export default {
	name: 'LexinBoyingResult',
    components: {
        Pronunciation,
        SpeakTextContent,
        LexinBoyingResultInflectionTable
    },
    data() {
        return {
            'boyingResultMobile': {
                "inflection_rows": {},
                "inflection_rows_additional": {}
            }
        };
    },
	props:{
        boyingResult: {
            required: false,
            default: () => ({
                "headers": [],
                "header": "",
                "sub_header": "",
                "sub_header_list": [],
                "lemma_rows": [],
                "inflection_rows": [],
                "inflection_rows_additional": []
            })
        },
        id: {
            required: false,
            default: "lexin-boying"
        },
        showHeader: {
            required: false,
            default: false
        },
        showLemma: {
            required: false,
            default: false
        },
        showPartisipp: {
            required: false,
            default: false
        },
        languageCode: {
            required: false,
            default: ''
        }
	},
    created() {
        this.initMobile();
    },
	methods:{
        initMobile() {
            if (this.boyingResult.inflection_rows !== undefined) {
                for (let i in this.boyingResult.inflection_rows) {
                    let inflectionRow = this.boyingResult.inflection_rows[i];

                    if (inflectionRow['cols'] !== undefined) {
                        for (let j in inflectionRow['cols']) {
                            // Clone column object.
                            let inflectionColumn = {...inflectionRow['cols'][j]};

                            if (this.boyingResultMobile['inflection_rows'][j] === undefined) {
                                this.boyingResultMobile['inflection_rows'][j] = {};
                                this.boyingResultMobile['inflection_rows'][j]['list'] = {};
                                this.boyingResultMobile['inflection_rows'][j]['header'] = "";

                                if (!this.boyingResultMobile['inflection_rows'][j]['header'] &&
                                    this.boyingResult.headers['headers']['mobile_left'] !== undefined &&
                                    this.boyingResult.headers['headers']['mobile_left'][j] !== undefined &&
                                    this.boyingResult.headers['headers']['mobile_left'][j]['value'] !== undefined) {
                                    let headerValue = this.boyingResult.headers['headers']['mobile_left'][j]['value'];
                                    if (this.$te(headerValue)) {
                                        this.boyingResultMobile['inflection_rows'][j]['header'] = this.$t(
                                            headerValue
                                        );
                                    } else {
                                        this.boyingResultMobile['inflection_rows'][j]['header'] = headerValue;
                                    }
                                }
                            }

                            inflectionColumn['colspan'] = inflectionColumn['rowspan'];
                            delete inflectionColumn['rowspan'];

                            this.boyingResultMobile['inflection_rows'][j]['list'][i] = inflectionColumn;
                        }
                    }
                }
            }

            if (this.boyingResult.inflection_rows_additional !== undefined &&
                this.boyingResult.inflection_rows_additional.rows !== undefined) {

                for (let i in this.boyingResult.inflection_rows_additional.rows) {
                    let inflectionRow = this.boyingResult.inflection_rows_additional.rows[i];

                    if (inflectionRow !== undefined && inflectionRow['cols'] !== undefined) {
                        for (let j in inflectionRow['cols']) {
                            // Clone column object.
                            let inflectionColumn = {...inflectionRow['cols'][j]};

                            if (this.boyingResultMobile['inflection_rows_additional'][j] === undefined) {
                                this.boyingResultMobile['inflection_rows_additional'][j] = {};
                                this.boyingResultMobile['inflection_rows_additional'][j]['list'] = {};
                                this.boyingResultMobile['inflection_rows_additional'][j]['header'] = "";

                                if (!this.boyingResultMobile['inflection_rows_additional'][j]['header'] &&
                                    this.boyingResult.headers['headers_additional']['mobile_left'] !== undefined &&
                                    this.boyingResult.headers['headers_additional']['mobile_left'][j] !== undefined &&
                                    this.boyingResult.headers['headers_additional']['mobile_left'][j]['value'] !== undefined) {
                                    let headerValue = this.boyingResult.headers['headers_additional']['mobile_left'][j]['value'];
                                    if (this.$te(headerValue)) {
                                        this.boyingResultMobile['inflection_rows_additional'][j]['header'] = this.$t(
                                            headerValue
                                        );
                                    } else {
                                        this.boyingResultMobile['inflection_rows_additional'][j]['header'] = headerValue;
                                    }
                                }
                            }

                            inflectionColumn['colspan'] = inflectionColumn['rowspan'];
                            delete inflectionColumn['rowspan'];

                            this.boyingResultMobile['inflection_rows_additional'][j]['list'][i] = inflectionColumn;
                        }
                    }
                }
            }
        },
        getOpenPartisipp() {
            return this.showPartisipp;
        },
        showAdditionalOpenCloseDetails() {
            let value = false;

            if (this.boyingResult.headers !== undefined &&
                this.boyingResult.headers.headers !== undefined &&
                this.boyingResult.headers.headers.show_hide !== undefined) {
                value = this.boyingResult.headers.headers.show_hide;
            }

            return value;
        },
        getAdditionalHeadersByType(type) {
            let value = [];

            if (this.boyingResult.headers !== undefined &&
                this.boyingResult.headers['headers_additional'] !== undefined &&
                this.boyingResult.headers['headers_additional'][type] !== undefined) {
                value = this.boyingResult.headers['headers_additional'][type];
            }

            return value;
        },
        getHeadersByType(type) {
            let value = [];

            if (this.boyingResult.headers !== undefined &&
                this.boyingResult.headers['headers'] !== undefined &&
                this.boyingResult.headers['headers'][type] !== undefined) {
                value = this.boyingResult.headers['headers'][type];
            }

            return value;
        },
        hasHeaderValue() {
            let value = false;
            if (this.getHeaderValue() !== '') {
                value = true;
            }

            return value;
        },
        getHeaderValue() {
            let value = '';
            if (this.boyingResult.header !== undefined) {
                value = this.boyingResult.header;
            }

            return value;
        },
        getTranslatedValue(value) {
            if (this.$te(value)) {
                return this.$t(value);
            } else {
                return value;
            }
        },
        getSubHeaderValue() {
            let value = '';
            if (this.boyingResult.sub_header !== undefined) {
                value = this.boyingResult.sub_header;
            }

            return value;
        },
        getSubHeader() {
            return this.getSubHeaderValue();
        },
        showSubHeader() {
            let value = false;
            if (this.boyingResult['headers']) {
                if ((this.boyingResult['headers']["sub_header"] !== undefined && this.boyingResult['headers']["sub_header"] !== '') ||
                    (this.boyingResult['headers']["sub_header_list"] !== undefined && this.boyingResult['headers']["sub_header_list"] !== '')) {
                    value = true;
                }
            }

            return value;
        },
        hasMobileInflectionRowHeaders() {
            let value = false;

            if (this.boyingResult['headers'] !== undefined &&
                this.boyingResult['headers']['headers'] !== undefined &&
                this.boyingResult['headers']['headers']['mobile_top'] !== undefined &&
                this.getListLength(this.boyingResult['headers']['headers']['mobile_top']) > 0) {
                value = true;
            }

            return value;
        },
        getMobileInflectionRowHeaders() {
            let value = [];

            if (this.boyingResult['headers'] !== undefined &&
                this.boyingResult['headers']['headers'] !== undefined &&
                this.boyingResult['headers']['headers']['mobile_top'] !== undefined) {
                value = this.boyingResult['headers']['headers']['mobile_top'];
            }

            return value;
        },
        getMobileInflectionRows() {
            let value = [];

            if (this.boyingResultMobile['inflection_rows'] !== undefined) {
                value = this.boyingResultMobile['inflection_rows'];
            }

            return value;
        },
        getMobileAdditionalInflectionRows() {
            let value = [];

            if (this.boyingResultMobile['inflection_rows_additional'] !== undefined) {
                value = this.boyingResultMobile['inflection_rows_additional'];
            }

            return value;
        },
        get_col_value(col_item, col_value) {
            let value = col_value;
            if (col_item.is_translation_key !== undefined && col_item.is_translation_key === true) {
                value = this.$t(col_value);
            }

            return value;
        },
        colValueHasContent(col_value) {
            let value = false;
            if (col_value && col_value !== '-') {
                value = true;
            }

            return value;
        },
        hasTopHeader() {
            let value = false;
            if (this.boyingResult.headers !== undefined &&
                this.boyingResult.headers.headers !== undefined &&
                this.boyingResult.headers.headers.top !== undefined &&
                this.getListLength(this.boyingResult.headers.headers.top) > 0) {
                value = true;
            }

            return value;
        },
        hasContent() {
            let value = false;

            if (this.getListLength(this.boyingResult.inflection_rows) > 0 &&
                this.getListLength(this.boyingResult.headers) > 0) {
                value = true;
            }

            return value;
        },
        getInflectionColumnClass(item) {
            let value = 'cell';
            if (item.class_list !== undefined) {
                value += ' ' + item.class_list.join(' ');
            }

            return value;
        },
        getListLength(list) {
            let length = 0;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                length = Object.keys(list).length;
            } else if (typeof list == "array") {
                length = list.length;
            }

            return length;
        },
        getMetaGridClass() {
            let value = 'grid-table';
            let headerCount = this.getListLength(this.boyingResult.headers);
            if (headerCount > 0) {
                value += ' g-col-' + headerCount;
            }
            value += ' g-m-col-2';
            return value;
        },
        getBoyingId(rootId) {
            const id = this.id + "-" + rootId + '-' + this.languageCode;

            return id;
        },
        getlemmaSpeakerId(rowIndex) {
            const id = this.id + "-lemma-" + rowIndex;

            return id;
        },
        getSpeakerId(rowIndex, colIndex, col_value_index = 0) {
            const id = this.id + "-" + rowIndex + "-" + colIndex + "-" + col_value_index;

            return id;
        },
        getBlockSpeakerId(rowIndex, colIndex, postfix) {
            return this.getSpeakerId(rowIndex, colIndex) + postfix;
        },
        getRowClass(rowIndex) {
            return "cell g-row-" + rowIndex;
        },
        getColumnValue(column_value) {
            let value = '';
            if (typeof column_value === "object" && column_value['value'] !== undefined) {
                value = column_value.value;
            } else if (typeof column_value === "string") {
                value = column_value;
            }

            return value;
        },
        getDataHeader(colIndex) {
            let value = '';

            if (this.boyingResult.headers[colIndex] !== undefined) {
                value = this.boyingResult.headers[colIndex];
            }

            return value;
        },
        handleMouseOver(mouseOver, rootElementId, item) {
            for (let i in (item.class_list || [])) {
                let className = item.class_list[i];
                if (mouseOver) {
                    $("#" + rootElementId).addClass(className);
                } else {
                    $("#" + rootElementId).removeClass(className);
                }
            }
        },
        isKloyvdInfinitiv(params) {
            let value = false;
            if (typeof params === "object" &&
                params.settings !== undefined &&
                params.settings.includes("kloyvd_infinitiv")) {
                value = true;
            }

            return value;
        }
    },
    computed: {
    }
}
</script>
